/* src/app/components/payroll/timesheets/timesheets-add-entries/timesheets-add-entries.component.css */
::ng-deep ppl-dialog ppl-timesheets-add-entries span.serviceDate:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
}
.custom-width {
  max-width: 160px;
  min-width: 50px;
  display: inline-block;
  margin: 0 6px;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0 !important;
}
.control-height {
  height: 30px;
}
.custom-btn-row {
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error-border {
  border: 1px solid red !important;
}
::ng-deep .ant-picker-input > input {
  border: none;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
.ant-checkbox-wrapper.error-class {
  border: 1px solid red !important;
}
.alert-box li {
  border-bottom: 1px solid #f0dca0;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.alert-box li:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.mobile-ui.card-layout .card {
  width: 90vw;
}
.mobile-ui.card-layout .card .card-item {
  display: flex;
  align-items: flex-start;
}
.mobile-ui.card-layout .card .card-item .card-buttons {
  flex-direction: row-reverse;
}
.mobile-ui.card-layout .card .card-item > * {
  padding: 4px 4px;
}
.mobile-ui.card-layout .card .card-item .service-select {
  width: 100%;
}
.mobile-ui.card-layout .card .card-item .billed-units {
  width: 30%;
  margin: 4px;
  padding-left: 8px;
}
.mobile-ui.card-layout .card .card-item .manual-reason-select {
  width: 100%;
}
.mobile-ui.card-layout .card .card-item .status-container {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  width: 50%;
}
.mobile-ui.card-layout .card .card-item .status-text {
  margin: 0;
  font-weight: normal;
}
.mobile-ui.card-layout .card .card-item .label {
  font-weight: bold;
}
.mobile-ui.card-layout .card .card-item:nth-child(1) {
  gap: 16px;
}
.mobile-ui.card-layout .card .card-item:last-child {
  justify-content: flex-end;
  gap: 8px;
}
/*# sourceMappingURL=timesheets-add-entries.component-VBLLD3TN.css.map */
